import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { nav, socials } from '../data/site';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'done'>('idle');
  return <footer className="border-t border-charcoal/[0.08] bg-ivory px-6 pb-12 pt-20 sm:px-10" data-id="element-45" data-mp="36oo87e4lrbso">
      <div className="mx-auto max-w-[92rem]" data-id="element-46" data-mp="3ueilfwsu32dg">
        <div className="grid gap-14 lg:grid-cols-12" data-id="element-47" data-mp="3uftmhouw9w0v">
          <div className="lg:col-span-5" data-id="element-48" data-mp="398y6cw8527j">
            <Link to="/" className="text-[0.8125rem] font-medium uppercase tracking-[0.32em] text-charcoal" data-id="element-49" data-mp="37xx4ku5y8k4">
              Amoye&nbsp;Henry
            </Link>
            <p className="mt-6 max-w-sm font-serif text-2xl font-light leading-snug text-charcoal/70" data-id="element-50" data-mp="3qblwzpgm4c1l">
              Founder. Operator. Investor. Strategist.
            </p>
            <p className="mt-8 font-script text-3xl text-mocha" data-id="element-51" data-mp="2ezbf4e3eq0bx">Amoye</p>
          </div>

          <nav className="lg:col-span-3" aria-label="Footer" data-id="element-52" data-mp="3l8qxu8j60rtk">
            <p className="eyebrow text-charcoal/40" data-id="element-53" data-mp="3gagzjp259b3q">Navigate</p>
            <ul className="mt-6 grid grid-cols-2 gap-y-3" data-id="element-54" data-mp="3gc0gzizjds73">
              {nav.map(item => <li key={item.to} data-id="element-55" data-mp="3v9az3b6opwbs">
                  <Link to={item.to} className="link-underline text-sm text-charcoal/70 transition-colors hover:text-charcoal" data-id="element-56" data-mp="3q8mypywkg34w">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-4" data-id="element-57" data-mp="hsk2qqetg2we">
            <p className="eyebrow text-charcoal/40" data-id="element-58" data-mp="hsabz0ly5rpn">Newsletter</p>
            <p className="mt-6 text-sm leading-relaxed text-charcoal/70" data-id="element-59" data-mp="ct783jhpdrj9">
              Occasional letters on company building, capital and the long game.
              No noise.
            </p>
            <form className="mt-6 flex items-center gap-3 border-b border-charcoal/20 pb-3" onSubmit={e => {
            e.preventDefault();
            if (email.trim()) setStatus('done');
          }} data-id="element-60" data-mp="msg7wsz920dj">
              <label htmlFor="newsletter-email" className="sr-only" data-id="element-61" data-mp="ys3f8e5fmz01">
                Email address
              </label>
              <input id="newsletter-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" className="w-full bg-transparent text-sm text-charcoal placeholder:text-charcoal/35 focus:outline-none" data-id="element-62" data-mp="18k0srrjwy31x" />
              <button type="submit" aria-label="Subscribe" className="text-charcoal/60 transition-colors hover:text-charcoal" data-id="element-63" data-mp="1mhpfl4xjjk9m">
                {status === 'done' ? <CheckIcon className="h-4 w-4" strokeWidth={1.4} data-id="element-64" data-mp="3t9q4hvpbl8qe" /> : <ArrowRightIcon className="h-4 w-4" strokeWidth={1.4} data-id="element-65" data-mp="2aevf3w32tu7d" />}
              </button>
            </form>
            {status === 'done' && <p className="mt-3 text-xs text-mocha" data-id="element-66" data-mp="25mamgxvwpn5f">
                Thank you — you’re on the list.
              </p>}

            <ul className="mt-10 flex gap-6" data-id="element-67" data-mp="1wnywmy2v6te1">
              {socials.map(s => <li key={s.label} data-id="element-68" data-mp="2tdzjgrjoazsp">
                  <a href={s.href} target="_blank" rel="noreferrer" className="link-underline text-[0.75rem] uppercase tracking-[0.18em] text-charcoal/60 hover:text-charcoal" data-id="element-69" data-mp="2tcy8so6kkfbi">
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-3 border-t border-charcoal/[0.08] pt-6 text-xs text-charcoal/45 sm:flex-row sm:items-center sm:justify-between" data-id="element-70" data-mp="18yxm95ah1864">
          <p data-id="element-71" data-mp="2rvzm7cez23t6">© {new Date().getFullYear()} Amoye Henry. All rights reserved.</p>
          <p data-id="element-72" data-mp="2rtwm1zk3uuaq">London · Lagos · Global</p>
        </div>
      </div>
    </footer>;
}